import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { BootstrapGrid } from "../../../../components/layouts/BootstrapGrid";
import PageWrapper from "../../../../components/layouts/PageWrapper";
import Spinner from "../../../../components/Spinner";
import { getBookingAsync } from "../../../../redux/reducers/bookings/actions";
import { RootState } from "../../../../redux/rootReducers";
import imgLogo from "../../../../static/images/logoBarnabas.png";

const ReportUsers = () => {
  const dispatch = useDispatch();

  const bookings = useSelector((state: RootState) => state.booking.bookings);
  const isLoading = useSelector((state: RootState) => state.booking.isLoading);
  
  const populateData = () => {
    dispatch(getBookingAsync.request({ page: 0 }));
  };

  useEffect(() => {
    populateData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderBookingList = () => {
    if (isLoading) {
      return (
        <div className="tablewrapper--loading--caption">
          <Spinner size="small" />
          <span>Memuat data...</span>
        </div>
      );
    }

    if (bookings.length > 0) {
      return bookings.map(booking => {
        return booking.rooms.map(room => {
          return (
            <div className='reportUser' key={booking.id}>
              <div className='reportUser-header'>
                <div className='reportUser-header__logo'>
                  <img src={imgLogo} alt='' />
                </div>
                <div className='reportUser-header__title'>
                  
                </div>
              </div>
              <BootstrapGrid>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <p><b>KEGIATAN</b></p>
                        <p>{booking.description}</p>
                      </div>
                      <div className='col-md-6'>
                        <p><b>RUANGAN</b></p>
                        <p>{ room.room_detail?.room_building }</p>
                      </div>
                    </div>

                    <p style={{ marginTop: '20px' }}><b>SYARAT DAN KETENTUAN</b></p>
                    <p>
                      <ul>
                        <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                        <li>Cras ullamcorper, enim vel convallis rutrum, felis neque vulputate mi, cursus laoreet nisl est ut lorem.</li>
                        <li>Sed non turpis turpis. Nunc nulla lorem, sagittis eu aliquet at, rutrum eget ex. Cras eleifend cursus aliquet. Fusce quis justo.</li>
                        <li>Convallis, finibus urna ac, consequat mauris.</li>
                        <li>Cras congue tristique lorem a dictum. Donec rhoncus ante quis.</li>
                      </ul>
                    </p>
                  </div>
                  <div className='col-md-6'>
                    <div className='row'>
                      <div className='col-md-6'>
                        <p><b>WAKTU KEGIATAN</b></p>
                        <p>{moment(booking.start_date).format('DD MMM YYYY')}, {moment(booking.start_date).format('HH:MM')} - {moment(booking.end_date).format('HH:MM')}</p>
                      </div>
                      <div className='col-md-6'>
                        <p><b>INVENTARIS</b></p>
                        <p>
                          <ul style={{ margin: 0 }}>
                            <li>1 laptop serbaguna</li>
                            <li>1 proyektor EPSON</li>
                          </ul>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </BootstrapGrid>
              <div className='reportUser-signature'>
                <BootstrapGrid>
                  <div className='row'>
                    <div className='col-md-6'>
                      <div className='reportUser-signature__item'>
                        <p><b>TTD PEMINJAM</b></p>
                        <br/><br/><br/><br/>
                        <p>{booking.user_detail?.name}</p>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='reportUser-signature__item'>
                        <p><b>TTD PPG</b></p>
                        <br/><br/><br/><br/>
                        <p>_____________________</p>
                      </div>
                    </div>
                  </div>
                </BootstrapGrid>
              </div>
            </div>
          );
        })
      })
    } else {
      return (
        <p>No booking data was found</p>
      );
    }
  }

  return (
    <PageWrapper>
      <ReportUsersWrapper>
        {renderBookingList()}
      </ReportUsersWrapper>
    </PageWrapper>
  )
}

const ReportUsersWrapper = styled.div`
  @media print {
    @page { size: landscape; }
  }
  .reportUser {
    padding: 15px;
    background: #fff;
    position: relative;
    border-radius: 5px;
    margin-bottom: 10px;
    break-inside: avoid;
    border: 1px solid #000;
    &-header {
      &__logo {
        & > img {
          width: 60px;
        }
      }
      margin-bottom: 20px;
    }
    &-signature {
      right: 15px;
      bottom: 15px;
      position: absolute;

      &__item {
        padding: 5px;
        width: 175px;
        height: 125px;
        text-align: center;
        border: 1px solid #000;
      }
    }
  }
`;

export default ReportUsers;